module.exports = __webpack_public_path__ + "static/dunning-retention-screenshot-eaa0354a5c1b4088e3a3db186cb33e51.png";